import { REMOVE_DEVICES_FROM_SUBSCRIPTION_MAP, SUBSCRIBE_DEVICE_DATA, UNSUBSCRIBE_DEVICE_DATA, RECEIVE_DEVICE_REALTIME_DATA } from '../constants/ActionTypes';
import { CustomAction } from 'model/state';
import { RealTimeDeviceData } from 'model';

/**
 * Payload
 */
export interface RealtimePayload {
  macAddresses?: string[];
  data?: RealTimeDeviceData;
}

/**
 * Actions
 */
export const subscribeDeviceData = (macAddresses: string[]): CustomAction<RealtimePayload> => ({
  type: SUBSCRIBE_DEVICE_DATA,
  payload: { macAddresses }
});

export const unSubscribeDeviceData = (): CustomAction<RealtimePayload> => ({
  type: UNSUBSCRIBE_DEVICE_DATA,
});

export const removeDevicesFromSubscriptionMap = (macAddresses: string[]): CustomAction<RealtimePayload> => ({
  type: REMOVE_DEVICES_FROM_SUBSCRIPTION_MAP,
  payload: { macAddresses }
});

export const receiveDeviceRealtimeData = (data: RealTimeDeviceData): CustomAction<RealtimePayload> => ({
  type: RECEIVE_DEVICE_REALTIME_DATA,
  payload: { data }
});